

















































import { RRule, rrulestr } from 'rrule'
import Vue from 'vue'

export default Vue.extend({
  props: {
    value: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    validation: {
      hour: value => (value >= 0 && value < 24) || value == null,
      minute: value => value >= 0 && value < 60,
    },
    rrule: {} as any,
    freq: RRule.HOURLY as any,
    freqOptions: [
      { name: 'Ежечасно', id: RRule.HOURLY },
      { name: 'Раз в сутки', id: RRule.DAILY },
    ],
    daysOptions: [RRule.MO, RRule.TU, RRule.WE, RRule.TH, RRule.FR, RRule.SA, RRule.SU],
    daysNames: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'],
  }),
  watch: {
    rrule: {
      deep: true,
      handler(value) {
        if (value == null) {
          return null
        }

        this.$emit('input', value.toString())
      },
    },
  },
  created() {
    this.rrule = rrulestr(this.value)
  },
  methods: {
    onFreqChange(event) {
      if (event == RRule.DAILY && this.rrule.origOptions.byhour == null) {
        this.rrule.origOptions.byhour = 0
      } else if (event == RRule.HOURLY) {
        this.rrule.origOptions.byhour = undefined
      }
    },
  },
})
